import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 5;
const DistrictGroupMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};

export default DistrictGroupMain;
